var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 653,
    height: 226,
    viewBox: "0 0 653 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7 62C72.8208 62 86.6999 48.1208 86.6999 31C86.6999 13.8792 72.8208 0 55.7 0C38.5791 0 24.7 13.8792 24.7 31C24.7 48.1208 38.5791 62 55.7 62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M568 29.2H515.3L452.7 179.7H349.3V148.3H442.6V105.7H348.6V77.7H451.3V29.2H296V83C296 83 289.7 64 266.7 48.3C243.7 32.6 229.4 29.2 200.7 29.2H121.3V199H95C92.0826 199 89.2847 197.841 87.2218 195.778C85.1589 193.715 84 190.917 84 188V80H0V106.3H19.3C22.4826 106.3 25.5348 107.564 27.7853 109.815C30.0357 112.065 31.3 115.117 31.3 118.3V183C31.3 187.243 29.6143 191.313 26.6137 194.314C23.6131 197.314 19.5435 199 15.3 199H0V225.7H197.3C233.3 225.7 246 219 262 209C278 199 295.3 175 295.3 175V225.7H491.3L504.6 192.4H580L592.7 225.7H652.7L568 29.2ZM200 177.7H176V79H208C220.7 79 250.7 94.3 250.7 128.3C250.7 162.3 228 177.7 200 177.7ZM520.7 148.4L542.7 93.7L563.4 148.4H520.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.59358e077f13f5d3deefaa228b2664b0.svg";
export { ForwardRef as ReactComponent };